import React, { useState } from 'react'
import { DatePicker, Form, Input, InputNumber, message, Modal } from 'antd'
import { useShangpindingdanAddMutation } from '../../store/dianshangtaizhangApi';
import FirmSelect from '../firm/FirmSelect';
import dayjs from 'dayjs'
import FirmUserSelect from '../firmUser/FirmUserSelect';
import GoodsSpecSelect from '../goodsSpec/GoodsSpecSelect';
function GoodsOrderAdd(props) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm(); 
    const [submit] = useShangpindingdanAddMutation();
    const [info,setInfo] = useState({
        spdd_content:''
    })
    return (
        <>
            <a onClick={() => {setOpen(true)}}> 新增订单</a>
            <Modal
                open={open}
                title='新增订单'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submit({
                        'spdd_spgg_price': info.spdd_spgg_price,
                        'spdd_qy_id': info.spdd_qy_id,
                        'spdd_qy_name': info.spdd_qy_name,
                        'spdd_jiaofei_date': info.spdd_jiaofei_date,
                        'spdd_jieshu_date': info.spdd_jieshu_date,
                        'spdd_uid': localStorage.getItem('eu_id'),
                        'spdd_uname': localStorage.getItem('eu_name'),
                        'spdd_content': info.spdd_content,
                        'spdd_yonghushu': info.spdd_spgg_price,
                        'spdd_state': '1',
                        'spdd_sp_id': info.spdd_sp_id,
                        'spdd_sp_name': info.spdd_sp_name,
                        'spdd_spgg_id': info.spdd_spgg_id,
                        'spdd_spgg_name': info.spdd_spgg_name,
                        'spdd_gly_id': info.spdd_gly_id,
                        'spdd_gly_name': info.spdd_gly_name,
                        'spdd_gly_phone': info.spdd_gly_phone,
                        spdd_amount:'1',
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            setOpen(false)
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_goods_order_add"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}   
                >                                                       
                    <GoodsSpecSelect
                        direction="vertical"
                        label="规格"     
                        nameOne="spdd_sp_name"
                        nameTwo="spdd_spgg_name"
                        required
                        onChangeOne={(e,f) => {
                            setInfo(prevState=>({...prevState,spdd_sp_id:e,spdd_sp_name:f}))
                        }}
                        onChangeTwo={(e,f) => {
                            setInfo(prevState=>({...prevState,spdd_spgg_id:e,spdd_spgg_name:f}))
                        }}
                        defaultId={info.spdd_spgg_name}
                        wrapperCol={{span:10}}
                    />
                    <FirmSelect
                        label="企业"                    
                        onChange={(e,f,g,h) => {
                            console.log(e,f,g,h);
                            setInfo(prevState=>({...prevState,spdd_qy_id:e,spdd_qy_name:f}))
                        }}
                        wrapperCol={{span:6}}
                        required
                        name='spdd_qy_id'
                    /> 
                    <FirmUserSelect
                        label="管理员"                    
                        onChange={(e,f,g,) => {
                            console.log(e,f,g);
                            setInfo(prevState=>({...prevState,spdd_gly_id:e,spdd_gly_name:f,spdd_gly_phone:g}))
                        }}
                        wrapperCol={{span:6}}
                        required
                        qy_id={info.spdd_qy_id}
                        name='spdd_gly_id'
                    />                  
                    <Form.Item name="spdd_jiaofei_date" wrapperCol={{span:10}} required label='缴费日期'>                        
                        <DatePicker 
                            onChange={(e) => {setInfo(prevState=>({...prevState,spdd_jiaofei_date:dayjs(e).format('YYYY-MM-DD')}))}}
                            
                        />
                    </Form.Item>     
                    <Form.Item name="spdd_jieshu_date" wrapperCol={{span:10}} required label='结束日期'>                        
                        <DatePicker 
                            onChange={(e) => {setInfo(prevState=>({...prevState,spdd_jieshu_date:dayjs(e).format('YYYY-MM-DD')}))}}
                            
                        />
                    </Form.Item>      
                    <Form.Item name="spdd_spgg_price" wrapperCol={{span:10}} required label='价格'>                        
                        <InputNumber 
                            onChange={(e) => {setInfo(prevState=>({...prevState,spdd_spgg_price:e}))}}
                            min={1}
                            max={100000}
                        />
                    </Form.Item>     
                    <Form.Item name="spdd_content" wrapperCol={{span:10}} label='备注'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spdd_content:e.target.value}))
                        }}
                        
                    />
                    </Form.Item>   
                </Form>
            </Modal>
        </>
    )
}

export default GoodsOrderAdd